import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'

import Unidoo from '@sedoo/unidoo'
Vue.use(Unidoo)

//////////////////////////

/*const { networkInterfaces } = require('os');

const nets = networkInterfaces();

for(l in nets){
  console.log(l);
}

console.log(nets);*/

//////////

//{{window.location.protocol}} - {{window.location.host}}
Vue.config.productionTip = false


Vue.prototype.$run_mode = "NEO"  //DEVEL_NEO DEVEL NEO FULL


//Vue.prototype.runmode = "DEV";
//const g_TelPos = function(){ma_variable = "tout";}
//App.config.globalProperties


//window.v_TelPos = { timestamp :"2073:04-01 00:00:00",st : "12h00m00s" , ah : 0.0,   ra : 0.0 ,  dec : 0.0  ,airmass : -1, date:"2073-04-01", time :"01:00"};
/*Vue.prototype.g_TelPos = function(){

  return { timestamp :"2073:04-01 00:00:00",st : "12h00m00s" , ah : 0.0,   ra : 0.0 ,  dec : 0.0  ,airmass : -1};
  

};*/

//Vue.prototype.$unautretest = 'ok pour le debut'
//alert(window.location.protocol + "//" + window.location.host);


new Vue({
  router,
  vuetify,
  render: h => h(App),

}).$mount('#app')



//export default api



